import NextImage from "@components/NextImage";
import React from "react";

import {ImageExtension} from "../../utils/nextImageSource";

type Props = {
  src: string;
  header: string;
  list?: string[];
  backgroundColor: string;
  pattern: string;
  body?: string | null;
  className?: string;
  imgExtension?: ImageExtension;
};

const ColorCard: React.FC<Props> = ({
  src,
  header,
  backgroundColor,
  list,
  body,
  pattern,
  className,
  imgExtension = "jpg",
}) => (
  <div
    className={`pos-r ph8 pv8 pb20-xs br4 minh24rem oh maxw28 maxw20-sm ${className || ""}`}
    style={{backgroundColor}}
  >
    <div className="pos-r zIndex1">
      <NextImage
        src={src}
        extension={imgExtension}
        className="mb4"
        width={100}
        height={100}
        alt=""
      />
      <h3 className="mb4 font-csb fs24 fs20-sm maxw15 lh15">{header}</h3>
      {body && <p>{body}</p>}
      {list && (
        <ul className="font-ir-sm fs14-sm fs18 lh15 ml7" style={{listStyle: "unset"}}>
          {list.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
    </div>
    <NextImage
      src={`/paint-strokes/${pattern}`}
      extension="jpg"
      className="pos-a bottom0 left0"
      layout="fill"
      alt=""
    />
  </div>
);

export default ColorCard;
